import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../../Images/SAN Techn-logo.png'

function Register() {
    const [formData, setFormData] = useState({ fullname: '', email: '', password: '' });
    const [errors, setErrors] = useState({});
    const [successMessage, setSuccessMessage] = useState('');
    const [successState, setSuccessState] = useState(false);
    const navigate = useNavigate();
    const apiurl = process.env.REACT_APP_URL;

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        setErrors({ ...errors, [e.target.name]: '' });
    };

    const validate = () => {
        const newErrors = {};
        if (!formData.fullname) {
            newErrors.fullname = 'Name is required.';
        }
        if (!formData.email) {
            newErrors.email = 'Email is required.';
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            newErrors.email = 'Please enter a valid email address.';
        }
        if (!formData.password) {
            newErrors.password = 'Password is required.';
        } else if (formData.password.length < 6) {
            newErrors.password = 'Password must be at least 6 characters.';
        }
        return newErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        // Registration API call (replace with your endpoint)
        fetch(`${apiurl}/create-user`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ fullname: formData.fullname, email: formData.email, password: formData.password }),
        })
            .then(res => res.json())
            .then(data => {


                if (data.success === true) {
                    setSuccessState(true)
                    setSuccessMessage(data.message);
                    navigate('/admin/login');
                }
                else {
                    alert(data.message);
                }
            })
            .catch(err => {
                console.log('error in fetch user register', err);
            });
    };

    return (
        <main className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-100 to-blue-300">
            <section className="bg-white rounded-2xl shadow-xl p-10 w-full max-w-md">
                <div className="flex flex-col items-center mb-8">
                    <img src={logo} alt="Logo" className="h-20 mb-2" />
                    <h1 className="lg:text-3xl font-extrabold text-blue-900 mb-1 text-xl">SAN Technovation</h1>
                    <p className="text-gray-500 text-sm">Create your account to get started.</p>
                </div>
                <form className="space-y-6" onSubmit={handleSubmit}>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Name</label>
                        <input
                            type="text"
                            name="fullname"
                            value={formData.fullname}
                            onChange={handleChange}
                            className={`w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 transition ${errors.fullname ? 'border-red-500' : ''}`}
                            placeholder="Enter your name"
                        />
                        {errors.fullname && (
                            <p className="text-red-500 text-xs mt-1">{errors.fullname}</p>
                        )}
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                        <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            className={`w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 transition ${errors.email ? 'border-red-500' : ''}`}
                            placeholder="Enter your email"
                        />
                        {errors.email && (
                            <p className="text-red-500 text-xs mt-1">{errors.email}</p>
                        )}
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
                        <input
                            type="password"
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                            className={`w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 transition ${errors.password ? 'border-red-500' : ''}`}
                            placeholder="Enter your password"
                        />
                        {errors.password && (
                            <p className="text-red-500 text-xs mt-1">{errors.password}</p>
                        )}
                    </div>
                    {
                        successState &&
                        (
                            <p className="text-green-700 text-lg mt-1">{successMessage}</p>
                        )
                    }
                    <button
                        type="submit"
                        className="w-full py-2 bg-blue-600 text-white font-semibold rounded-lg shadow hover:bg-blue-700 transition"
                    >
                        Register
                    </button>
                </form>
                <div className="mt-6 text-center">
                    <span className="text-gray-600 text-sm">Already have an account? </span>
                    <Link to="/admin/login" className="text-blue-600 font-medium hover:underline">Login</Link>
                </div>
            </section>
        </main>
    );
}

export default Register